import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import Modal from "../../../../components/molecures/Modals/Modal";
import { AddressForm } from "../../../../components/organisms/Reservation/Detail/Address";
import { DeliveryServiceVendors } from "../../../../components/organisms/Reservation/utils/DeliveryService";
import { getValueEnum } from "../../../../components/organisms/Unbookable/utils";
import useModals from "../../../../hooks/useModals";
import { Delivery } from "../../../../model/ReservationDetail";
import sharedConstants from "../../../../shared/constants";
import { changeIsoToKorDate } from "../../../../shared/utils";
import { theme } from "../../../../theme";
import { StyledModalContainer } from "../../../ReservationConfig/styles";

interface Props {
  delivery?: Delivery;
}
const DeliveryDetailModal: React.FC<Props> = ({ delivery }) => {
  const { closeModal } = useModals();
  const dataForm: Delivery | undefined = delivery;

  return (
    <Modal
      width={700}
      onOk={closeModal}
      isOneBtn
      title="배송 상세"
      okButtonProps={{ ghost: true, type: "default" }}
      okText="닫기"
    >
      <StyledModalContainer>
        <Row gutter={[0, 24]}>
          <OneRow>
            <TitleCol>
              <HeaderTitleCol>발송정보</HeaderTitleCol>
            </TitleCol>
            <ContentCol />
          </OneRow>
          <OneRow>
            <TitleCol>운송장번호</TitleCol>
            <ContentCol>
              {dataForm?.trackingNo ? dataForm?.trackingNo : "-"}
            </ContentCol>
          </OneRow>
          <OneRow>
            <TitleCol>택배사</TitleCol>
            <ContentCol>
              <TextAreaCol>
                {(dataForm?.deliveryVendor &&
                  getValueEnum(
                    dataForm?.deliveryVendor,
                    DeliveryServiceVendors
                  )) ||
                  "-"}
              </TextAreaCol>
            </ContentCol>
          </OneRow>
          <OneRow>
            <TitleCol>발송일시</TitleCol>
            <ContentCol>
              <TextAreaCol>
                {dataForm?.deliveryStartedAt
                  ? changeIsoToKorDate(
                      dataForm?.deliveryStartedAt,
                      sharedConstants.date.formatYMDHMS
                    )
                  : "-"}
              </TextAreaCol>
            </ContentCol>
          </OneRow>
          <OneRow>
            <Line />
          </OneRow>
          <OneRow>
            <TitleCol>
              <HeaderTitleCol>발송자 정보</HeaderTitleCol>
            </TitleCol>
            <ContentCol />
          </OneRow>

          <OneRow>
            <TitleCol>발송자명</TitleCol>
            <ContentCol>
              <TextAreaCol>{dataForm?.senderName || "-"}</TextAreaCol>
            </ContentCol>
          </OneRow>
          <OneRow>
            <TitleCol>발송지</TitleCol>
            <ContentCol>
              <AddressForm
                detail={dataForm?.senderDetail}
                street={dataForm?.senderStreet}
                zibun={dataForm?.senderZibun}
              />
            </ContentCol>
          </OneRow>
          <OneRow>
            <Line />
          </OneRow>
          <OneRow>
            <TitleCol>
              <HeaderTitleCol>수신자 정보</HeaderTitleCol>
            </TitleCol>
            <ContentCol />
          </OneRow>
          <OneRow>
            <TitleCol>수신자명</TitleCol>
            <ContentCol>{dataForm?.receiverName || "-"}</ContentCol>
          </OneRow>
          <OneRow>
            <TitleCol>수신지</TitleCol>
            <ContentCol>
              <AddressForm
                detail={dataForm?.receiverDetail}
                street={dataForm?.receiverStreet}
                zibun={dataForm?.receiverZibun}
              />
            </ContentCol>
          </OneRow>
        </Row>
      </StyledModalContainer>
    </Modal>
  );
};
export default DeliveryDetailModal;

const HeaderTitleCol = styled.div`
  ${theme.typo.heading.b18};
  margin-bottom: 4px;
`;
const TitleCol: React.FC = ({ children }) => (
  <StyledTitleCol flex="0 0 165px">{children}</StyledTitleCol>
);
const ContentCol: React.FC = ({ children }) => (
  <Col flex="1 1 0">{children}</Col>
);
const OneRow: React.FC = ({ children }) => (
  <Col span={24}>
    <Row wrap={false}>{children}</Row>
  </Col>
);
const Line = styled.div`
  border-bottom: 1px solid ${theme.colors.gray7};
  width: 100%;
  margin: 8px;
`;

const StyledTitleCol = styled(Col)`
  ${theme.typo.heading.b16};
`;
const TextAreaCol: React.FC = ({ children }) => (
  <Col flex="1 1 0" style={{}}>
    {children}
  </Col>
);
